<template>
  <div class="crystal-selector" style="margin-right: 106px; flex-grow: 1;">
    <!--    <div class="crystal-selector__label">-->
    <!--      <span>{{label}}:</span>-->
    <!--    </div>-->
    <div
      ref="selector"
      :class="['crystal-selector__board', { active: active }]"
    >
      <div
        class="crystal-selector__input"
        @focus="active = true"
        :tabindex="tabIndex"
      >
        <div class="crystal-selector__context">
          <template v-for="(item, index) in display">
            <v-chip
              small
              v-if="index < showIndex"
              :key="index"
              @click="deleteChips(index)"
            >
              <span v-html="item.text"></span>
              <span><v-icon size="20">mdi-close-circle</v-icon></span>
            </v-chip>
            <span
              v-if="index === showIndex"
              class="grey--text caption"
              v-text="'(+' + (select.length - showIndex) + ' more)'"
              :key="index"
            >
            </span>
          </template>
        </div>
        <div class="crystal-selector__suffix">
          <v-icon>{{ icon }}</v-icon>
        </div>
      </div>
      <v-card class="crystal-selector__menu pa-0" height="261" v-if="active">
        <vue-scroll>
          <v-card-text class="pa-0">
            <v-list>
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                @click="change(i)"
              >
                <v-list-item-content>
                  <v-list-item-title v-html="item.text" />
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </vue-scroll>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "select",
    event: "change",
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    select: {
      type: Array,
      required: true,
    },
    tabIndex: {
      type: String,
      required: true,
    },
    showIndex: Number,
  },
  data: () => ({
    active: false,
    selects: [],
  }),
  computed: {
    icon() {
      return this.active ? "mdi-chevron-down" : "mdi-chevron-left";
    },
    display() {
      return this.select.map((x) => {
        return this.items[x];
      });
    },
  },
  watch: {
    // items:{
    //   handler(newV, oldV){
    //     if(newV.length === 0){
    //       this.$emit('change', [])
    //     }
    //   },
    //   deep: true
    // }
  },
  methods: {
    change(val) {
      let index = this.selects.indexOf(val);
      if (index > -1) {
        this.selects.splice(index, 1);
        this.selects.sort();
      } else {
        this.selects.push(val);
        this.selects.sort();
      }
      this.$emit("change", this.selects);
    },
    clickOutside() {
      const app = document.body;
      app.addEventListener("click", this.onClick, true);
    },
    onClick(e) {
      if (!this.$refs.selector.contains(e.target)) {
        this.active = false;
      }
    },
    unbind() {
      const app = document.body;
      app.removeEventListener("click", this.onClick, true);
    },
    deleteChips(index) {
      this.select.splice(index, 1);
    },
  },
  mounted() {
    this.clickOutside();
  },
  destroyed() {
    this.unbind();
  },
};
</script>

<style lang="scss">
.crystal-selector {
  display: flex;
  height: 2.5rem;
  &__board:hover {
    border: 1px solid #333;
  }
  &__board.active {
    border: 2px solid #1976d2;
  }
  &__label {
    width: 4rem;
    float: left;
    line-height: 2.5rem;
    font-size: 1rem;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
  }

  &__board {
    float: left;
    flex-grow: 1;
    padding: 2px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid #c2c2d2;
  }

  &__masking {
    position: relative;
    height: 295px;
  }

  &__input {
    width: 100%;
    display: flex;
    height: 34px;
    outline: none;
  }

  &__context {
    float: left;
    flex-grow: 1;
    margin: auto;
  }

  &__suffix {
    float: left;
    width: auto;
    margin: auto;
  }

  &__menu {
    position: relative;
    top: 2px;
    width: 100%;
    z-index: 10;
  }
}
</style>
